import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
import store from '@/store/index';
import watermark from "@/utils/watermark";
var CUSTOM_DEVELOP_ROUTES = [{
  id: 375,
  parentid: 0,
  title: '登录配置',
  url: '',
  method: 'get',
  son_menu: [{
    id: 352,
    parentid: 375,
    title: '登录类型配置',
    url: '/loginDisposition/loginTypeConfiguration',
    method: 'get',
    son_menu: []
  }, {
    id: 600,
    parentid: 375,
    title: '登录用户列表',
    url: '/loginDisposition/loginUserListIsDevelop',
    method: 'post',
    son_menu: []
  }, {
    id: 359,
    parentid: 375,
    title: '登录参数切换',
    url: '/loginDisposition/loginParameterSwitching',
    method: 'get',
    son_menu: []
  }, {
    id: 395,
    parentid: 375,
    title: '实名认证配置',
    url: '/authentication/nameAuthenticationbind',
    method: 'get',
    son_menu: []
  }, {
    id: 368,
    parentid: 375,
    title: '实名认证绑定',
    url: '/authentication/nameAuthentication',
    method: 'post',
    son_menu: []
  }, {
    id: 369,
    parentid: 375,
    title: '短信验证码配置',
    url: '/sms/smsSendConfiguration',
    method: 'post',
    son_menu: []
  }, {
    id: 414,
    parentid: 375,
    title: '手机一键登录配置',
    url: '/loginDisposition/mobileLoginParameters',
    method: 'get',
    son_menu: []
  }, {
    id: 415,
    parentid: 375,
    title: '应用版本登录配置',
    url: '/loginDisposition/applicationLoginTypeConfiguration',
    method: 'get',
    son_menu: []
  }, {
    id: 416,
    parentid: 375,
    title: '应用提审配置',
    url: '/loginDisposition/appSubmission',
    method: 'get',
    son_menu: []
  }]
}, {
  id: 385,
  parentid: 0,
  title: '支付配置',
  url: '',
  method: 'get',
  son_menu: [{
    id: 349,
    parentid: 385,
    title: '支付类型配置',
    url: '/payment/paymentDisposition',
    method: 'post',
    son_menu: []
  }, {
    id: 360,
    parentid: 385,
    title: '支付参数切换',
    url: '/payment/paymentParameterSwitching',
    method: 'post',
    son_menu: []
  }, {
    id: 355,
    parentid: 385,
    title: '商品映射配置',
    url: '/product/productConvertList',
    method: 'post',
    son_menu: []
  }]
}, {
  id: 392,
  parentid: 0,
  title: '支付中心',
  url: '',
  method: 'get',
  son_menu: [{
    id: 393,
    parentid: 392,
    title: '订单列表',
    url: '/payment/payOrderList',
    method: 'get',
    son_menu: []
  }, {
    id: 418,
    parentid: 392,
    title: '补单记录',
    url: '/payment/repairOrderList',
    method: 'get',
    son_menu: []
  }]
}, {
  id: 398,
  parentid: 0,
  title: '打包管理',
  url: '',
  method: 'get',
  son_menu: [{
    id: 399,
    parentid: 398,
    title: '游戏组管理',
    url: '/packagingManagement/gameGroup',
    method: 'get',
    son_menu: []
  }, {
    id: 400,
    parentid: 398,
    title: '母包管理',
    url: '/packagingManagement/motherPackage',
    method: 'get',
    son_menu: []
  }, {
    id: 401,
    parentid: 398,
    title: '游戏渠道管理',
    url: '/packagingManagement/motherPackageType',
    method: 'get',
    son_menu: []
  }, {
    id: 402,
    parentid: 398,
    title: '打包任务',
    url: '/packagingManagement/packagingTaskManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 404,
    parentid: 398,
    title: '配置文件管理',
    url: '/packagingManagement/profileManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 405,
    parentid: 398,
    title: '图标管理',
    url: '/packagingManagement/iconListManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 406,
    parentid: 398,
    title: 'SDK渠道',
    url: '/packagingManagement/threePartySDKTypeManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 407,
    parentid: 398,
    title: '渠道SDK',
    url: '/packagingManagement/threePartySDKManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 408,
    parentid: 398,
    title: '广告SDK渠道',
    url: '/packagingManagement/advertisingSDKTypeManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 409,
    parentid: 398,
    title: '广告渠道SDK',
    url: '/packagingManagement/advertisingSDKManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 410,
    parentid: 398,
    title: '包签名密钥管理',
    url: '/packagingManagement/packageKeyFileManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 411,
    parentid: 398,
    title: 'oaid密钥文件管理',
    url: '/packagingManagement/oaidFileManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 412,
    parentid: 398,
    title: '渠道上报参数管理',
    url: '/packagingManagement/reportConfigurationManagement',
    method: 'get',
    son_menu: []
  }, {
    id: 413,
    parentid: 398,
    title: '打包任务模板管理',
    url: '/packagingManagement/packagingModule',
    method: 'get',
    son_menu: []
  }]
}, {
  id: 1,
  parentid: 0,
  title: '权限中心',
  url: '',
  method: 'get',
  son_menu: [{
    id: 818,
    parentid: 1,
    title: '下级管理',
    url: '/auth/managingSubordinates',
    method: 'get',
    son_menu: []
  }]
}];
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref, formData) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return new Promise( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var formatRoutes;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  formatRoutes = function formatRoutes(routes) {
                    routes.forEach(function (route) {
                      route.path = route.url;
                      var paths = route.path ? route.path.split('/') : null;
                      route.name = paths ? paths[paths.length - 1] : '';
                      route.meta = {
                        title: route.title,
                        cache: true
                      };
                      route.children = route.son_menu || [];

                      if (route.son_menu.length) {
                        formatRoutes(route.son_menu);
                      }

                      delete route.son_menu;
                      delete route.url;
                    });
                  };

                  api.login(formData).then( /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
                      var formattedRoute, userInfo;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(res.status == 200)) {
                                _context.next = 27;
                                break;
                              }

                              util.cookies.set('token', res.data.token);
                              res.data.menu.map(function (i) {
                                i.topLevel = true;
                              });

                              if (!(res.data.user.is_develop == 2)) {
                                _context.next = 9;
                                break;
                              }

                              formatRoutes(res.data.menu); // 设置路由

                              _context.next = 7;
                              return store.dispatch('d2admin/db/set', {
                                dbName: 'sys',
                                path: 'menu.accessMenus',
                                value: res.data.menu,
                                user: true
                              }, {
                                root: true
                              });

                            case 7:
                              _context.next = 17;
                              break;

                            case 9:
                              formattedRoute = JSON.parse(JSON.stringify(CUSTOM_DEVELOP_ROUTES));

                              if (!res.data.user.user_tree) {
                                formattedRoute = formattedRoute.reduce(function (acc, item) {
                                  // 如果是权限中心节点
                                  if (item.id === 1 && item.son_menu) {
                                    var newSonMenu = item.son_menu.filter(function (sub) {
                                      return sub.url !== '/auth/managingSubordinates';
                                    });

                                    if (newSonMenu.length > 0) {
                                      acc.push(_objectSpread(_objectSpread({}, item), {}, {
                                        son_menu: newSonMenu
                                      }));
                                    } // 如果过滤后子菜单空了，就不 push 到 acc 中，相当于整个“权限中心”也被隐藏了

                                  } else {
                                    acc.push(item);
                                  }

                                  return acc;
                                }, []);
                              }

                              if (res.data.user.enterprise.status === 0) {
                                formattedRoute = [];
                              }

                              _context.next = 14;
                              return api.authAppList({
                                type: 'my'
                              }).then(function (resq) {
                                if (resq.status == 200 && resq.data.length == 0) {
                                  formattedRoute = [];
                                }
                              });

                            case 14:
                              formatRoutes(formattedRoute); // 设置路由

                              _context.next = 17;
                              return store.dispatch('d2admin/db/set', {
                                dbName: 'sys',
                                path: 'menu.accessMenus',
                                value: formattedRoute,
                                user: true
                              }, {
                                root: true
                              });

                            case 17:
                              _context.next = 19;
                              return api.getInfo();

                            case 19:
                              userInfo = _context.sent;
                              _context.next = 22;
                              return dispatch('d2admin/user/set', {
                                name: userInfo.data.info.nickname,
                                isLogin: true,
                                is_develop: res.data.user.is_develop,
                                enterprise: res.data.user.enterprise,
                                user_tree: res.data.user.user_tree
                              }, {
                                root: true
                              });

                            case 22:
                              _context.next = 24;
                              return dispatch('load');

                            case 24:
                              resolve(res);
                              _context.next = 28;
                              break;

                            case 27:
                              reject(err);

                            case 28:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }()).catch(function (err) {
                    reject(err);
                  });

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },

    /**
     * @description 退出用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref4) {
      var commit = _ref4.commit,
          dispatch = _ref4.dispatch;

      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$confirm = _ref5.confirm,
          confirm = _ref5$confirm === void 0 ? false : _ref5$confirm;

      /**
       * @description 退出
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  watermark.set(""); // 删除cookie

                  util.cookies.remove('token');
                  util.cookies.remove('uuid');
                  store.commit('d2admin/permission/setFet', false);
                  _context3.next = 6;
                  return dispatch('d2admin/page/closeAll', {}, {
                    root: true
                  });

                case 6:
                  _context3.next = 8;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 8:
                  store.dispatch('d2admin/db/set', {
                    dbName: 'sys',
                    path: 'menu.accessMenus',
                    value: [],
                    user: true
                  }, {
                    root: true
                  }); // 跳转路由

                  router.push({
                    name: 'login'
                  });

                case 10:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前登录吗', '退出登录', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消退出操作',
            duration: '1000'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref6) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref6.dispatch;
                _context4.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                // // 加载游戏类型
                // await dispatch('d2admin/init/load', null, {
                //   root: true
                // })
                if (util.cookies.get("token")) {
                  watermark.set("colocess-sdk-manage" + store.state.d2admin.user.info.name);
                } // 加载主题


                _context4.next = 6;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 6:
                _context4.next = 8;
                return dispatch('d2admin/transition/load', null, {
                  root: true
                });

              case 8:
                _context4.next = 10;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 10:
                _context4.next = 12;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 12:
                _context4.next = 14;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 14:
                _context4.next = 16;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};